/* eslint-disable no-unreachable */
import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { apiFetch } from '../../helpers/axiosHelper';
import {
  CHECK_ORG_NAME,
  apiUpdateOrganization,
  apiGetOrganizationDetails,
  apiGetMembers,
  apiChangeOrganizationOwner,
} from '../../helpers/api';
import { icons } from '../../assets';
import CancelIcon from '../../assets/images/settings/cancel.svg';
import { ViewEditItem } from '..';
import _ from 'lodash';
import { AvatarRow } from '../AvatarRow';
import { useUserContext } from '../../contexts/UserContext';
import Button from '../../components/Button/Button';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import InfoDialogUI from '../../components/InfoDialog/InfoDialogUI';
import styles from './OrgSection.module.scss';
import CloseCircleIcon from '../../components/icons/closeCircleIcon';
import { useSearchMemberList } from '../../hooks/useSearchMemberList';
import { ItemSelectListUI } from './ItemSelectListUI';
import { errorToast, successToast } from '../../helpers/toastHelper';
import { useDispatch } from 'react-redux';
import { getUserDisplayName } from '../../helpers/userHelper';
import { USER_PROFILE_PLACEHOLDER } from '../../config/constant/assetConstant';
import { checkFileSize, loadImage } from "../../helpers/jsHelper";
//import { captureException } from '@sentry/react';
import { updateAllOrg } from '../../redux/slicers/search/searchSlicer';

const { ChangeProfileIcon, EditIcon, EyeIcon, FigureIcon, ProfileIcon } = icons;

function OrgOwnerModal(props) {
  const { isOwner, isAdminOrOwner, updateUserData, currentUser } = useUserContext();
  const [showModal, setShowModal] = useState(false);
  const { openInfoDialog } = useInfoDialogaActions();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [ownershiChangeLoading, setOwnershiChangeLoading] = useState(false);

  const {
    list: memberList,
    fetchMoreData,
    loading,
    search,
    onSearchChange,
    hasData,
    hasMore,
  } = useSearchMemberList();

  const submitMakeOwner = async () => {
    if (!selectedUserId) {
      errorToast('Please select a new owner');
      return;
    }

    setOwnershiChangeLoading(true);
    let formData = new FormData();
    formData.append('member_id', selectedUserId);
    const result = await apiChangeOrganizationOwner(formData);

    const {
      owner_details: {
        role_details: { is_admin, is_external_member, is_internal_member, is_owner, is_staff, name },
      },
    } = result;

    if (result?.id) {
      updateUserData();
      successToast('Ownership transferred successfully');
      closeDialog();
    }
    setOwnershiChangeLoading(false);
    props.onOwnerChange();
  };

  const handleEditClick = () => {
    openInfoDialog({
      title: 'You will loose ownership & your role will be switched from owner to admin.',
      description: 'Are you sure you want to change the owner?',
      cancelButtonText: 'Cancel',
      buttonText: 'Yes',
      dialogClassName: 'ownership-modal-dialog ownership-modal-confirm-dialog',
      bodyClassName: 'ownership-modal-body',
      onButtonClick: () => setShowModal(true),
    });
  };

  const closeDialog = () => {
    if (ownershiChangeLoading) {
      return;
    }

    setShowModal(false);
    setSelectedUserId(null);
  };

  const formattedMemberList = useMemo(() => {
    return memberList
      .filter((m) => m.id !== currentUser.id)
      .map((m) => ({
        id: m.id,
        image: m.user.profile_image,
        title: getUserDisplayName(m.user),
        description: m.user.email,
      }));
  }, [memberList]);

  return (
    <>
      <div className="input-border d-flex justify-content-between gap-3">
        <div>
          <label className="detail-label">Organization Owner</label>
          <span className="detail-info">{props?.orgOwner?.email}</span>
        </div>
        {isAdminOrOwner && (
          <Button
            onClick={handleEditClick}
            color="light"
            size="xlg"
            className="so-icon-button"
            iconBefore={<EditIcon />}>
            Edit
          </Button>
        )}
      </div>

      <InfoDialogUI
        show={showModal}
        preventClose={ownershiChangeLoading}
        title="Select organization owner"
        onClose={closeDialog}
        dialogClassName="ownership-modal-dialog">
        <div className={styles.searchInputContainer}>
          <Form.Control
            className={styles.searchInput}
            type={'text'}
            placeholder="Search..."
            maxLength={20}
            value={search}
            onChange={onSearchChange}
          />
          {search && (
            <CloseCircleIcon
              className={styles.clearInputButton}
              onClick={() => onSearchChange('')}
            />
          )}
        </div>
        <ItemSelectListUI
          className="mb-4 orgMembersList"
          items={formattedMemberList}
          selected={selectedUserId}
          onChange={setSelectedUserId}
          loading={loading}
          hasData={hasData}
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          placeholder={USER_PROFILE_PLACEHOLDER}
        />
        <Button
          color="warning"
          onClick={submitMakeOwner}
          fullWidth
          size="xlg"
          loading={ownershiChangeLoading}>
          Make owner
        </Button>
      </InfoDialogUI>
    </>
  );
}

export default function OrgSection(props) {
  const dispatch = new useDispatch();
  const userCtx = useUserContext();
  const { isAdmin, isOwner, isAdminOrOwner, setOrgOwnerDetail } = useUserContext();
  const [selectedOrgPhoto, setSelectedOrgPhoto] = useState('images/orgPic.svg');
  const [orgError, setOrgError] = useState(false);
  const [orgErrorMsg, setOrgErrorMsg] = useState('');
  const [saving, setSaving] = useState(false);
  const [savingImg, setSavingImg] = useState(false);
  const [savingWatermarkImg, setSavingWatermarkImg] = useState(false);
  const [orgName, setOrgName] = useState('');
  const [orgInfo, setOrgInfo] = useState({});
  const [orgId, setOrgId] = useState();
  const [orgOwnerId, setOrgOwnerId] = useState();
  const [orgOwner, setOrgOwner] = useState({});
  const [orgMembers, setOrgMembers] = useState([]);
  const [editingOrgName, seon] = useState(false);

  const { userDetails } = props;
  const setEditingOrgName = (active) => {
    seon(active);
    if (!active) {
      setOrgError(false);
      setOrgErrorMsg('');
    }
  };

  useEffect(() => {
    if (!editingOrgName) return;
    setOrgName(userDetails?.organization_details?.name || '');
  }, [editingOrgName]);

  useEffect(() => {
    getOrgInfo();
  }, [userDetails, userCtx.currentUser.organization, userCtx.currentUser.role?.is_owner]);

  useEffect(() => {
    getOrgOwner();
  }, [orgId, orgOwnerId]);

  function getOrgInfo() {
    apiGetOrganizationDetails().then((response) => {
      if (response) {
        setOrgInfo(response);
        setOrgOwnerId(response.owner);
        setOrgId(response.id);
        setOrgOwnerDetail(response?.owner_details);
      }
    });
  }

  function getOrgOwner() {
    if (!orgOwnerId) return;

    apiGetMembers({ search: `id=${orgOwnerId}` }).then((response) => {
      setOrgMembers(formatOrgMembers(response.results));
      let owner = _.find(response.results, (x) => x.id === orgOwnerId);
      setOrgOwner(owner?.user);
    });
  }

  function formatOrgMembers(arr) {
    let newArray = _.map(arr, (item) => {
      let newItem = {};
      newItem.label = item.user.name ? item.user.name : '';
      newItem.value = item.id;
      newItem.email = item.user.email ? item.user.email : '';
      newItem.profile_image = item.user.profile_image;
      return newItem;
    });
    return newArray;
  }

  const handleOrganizationImage = async (file) => {
    if (checkFileSize(file.size, 5)) {
      let formData = new FormData();

      formData.append('thumbnail', file);
      setSavingImg(true);

      try {
        const response = await apiUpdateOrganization(formData)
        if (response?.thumbnail) {
          await loadImage({ src: response.thumbnail })
          dispatch(updateAllOrg({ id: orgInfo.id, thumbnail: response.thumbnail }))
          setOrgInfo({ ...orgInfo, thumbnail: response?.thumbnail })
          userCtx.changeOrgProfilePic(response?.thumbnail);
        }
      } catch (e) {
        //captureException(e);
        errorToast('Something went wrong while updating organization image')
      }
      setSavingImg(false)
    } else {
      errorToast("You attachment must not exceed 5 Mb.")
    }
  };

  const handleWatermarkImage = async (file) => {
    if (checkFileSize(file.size, 5)) {
      let formData = new FormData();

      formData.append('watermark_on_rendering', file);
      setSavingWatermarkImg(true);

      try {
        const response = await apiUpdateOrganization(formData)
        if (response?.thumbnail) {
          await loadImage({ src: response.watermark_on_rendering })
          dispatch(updateAllOrg({ id: orgInfo.id, watermark_on_rendering: response.watermark_on_rendering }))
          setOrgInfo({ ...orgInfo, watermark_on_rendering: response?.watermark_on_rendering })
        }
      } catch (e) {
        //captureException(e);
        errorToast('Something went wrong while updating watermark')
      }
      setSavingWatermarkImg(false)
    } else {
      errorToast("You attachment must not exceed 5 Mb.")
    }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOrgSave = () => {
    setIsSubmitting(true);
    let formData = new FormData();
    formData.append('name', orgName.trim());

    apiUpdateOrganization(formData)
      .then((response) => {
        if (response) {
          props.getUserDetails(() => setEditingOrgName(false));
        }
      }).catch((error) => {
        errorToast(
          error?.message ||
          'Something went wrong while updating organization name. Please try again later!'
        );
      })
      .catch((error) => {
        errorToast(
          error?.message ||
          'Something went wrong while updating organization name. Please try again later!'
        );
      })
      .finally(() => {
        window.$updateName = true;
        setIsSubmitting(false);
      });
  };

  const handleOrgNameChange = async (e) => {
    let name = e.target.value;

    if (name?.length === 0) setOrgErrorMsg("Organization name can't be empty");
    else if (name?.length > 50)
      setOrgErrorMsg('Organization name should be less then 50 character');
    else setOrgErrorMsg('');
    setOrgName(name);

    if (name.length > 0) {
      const data = await apiFetch(`${CHECK_ORG_NAME}?name=${name}`).send();
      setOrgError(!data?.status);
      if (!data?.status) setOrgErrorMsg(data?.message);

      if (name.length > 50) {
        setOrgError(true);
      }
    } else {
      setOrgError(true);
    }
  };

  return (
    <div>
      <div className="right-section">
        <div className="org-details">
          <AvatarRow
            src={orgInfo.thumbnail}
            label="Organization Picture"
            onFileSelect={handleOrganizationImage}
            loading={savingImg}
            disableEdit={!isAdminOrOwner}
          />

          <ViewEditItem
            label={orgErrorMsg !== '' ? orgErrorMsg : 'Organization Name'}
            // label={
            //   !(orgName.length > 50) || !editingOrgName
            //   ? "Organization Name"
            //   : <>
            //       <img
            //         src={UnionExclamation}
            //         style={{ verticalAlign: 'text-top', marginRight: '0.2rem' }}
            //       />
            //       Organization name should be less then 50 character
            //     </>
            // }
            disabled={orgError || isSubmitting}
            onUpdate={handleOrgSave}
            value={userDetails?.organization_details?.name}
            editing={editingOrgName}
            error={orgError}
            orgErrorMsg={orgErrorMsg}
            placeholder="Organisation Name"
            setEditing={setEditingOrgName}
            disableEdit={!isAdminOrOwner}
            isSubmitting={isSubmitting}>
            <div className="w-100">
              <Form.Control
                className={`w-100 my-details-input ${(orgName.length > 50 && editingOrgName) || orgError ? 'input-error' : ''
                  } `}
                value={orgName}
                maxLength={50}
                onChange={handleOrgNameChange}
                style={{ border: orgError ? 'var(--error-color) 1px solid' : '' }}
                placeholder="Organization Name"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !orgError) {
                    if (orgName.length > 50) return;
                    handleOrgSave();
                    // setEditingOrgName(false);
                  }
                }}
              />
            </div>
          </ViewEditItem>
          <OrgOwnerModal orgOwner={orgOwner} orgMembers={orgMembers} onOwnerChange={getOrgInfo} />

          {/* watermark on rendering */}
          <AvatarRow
            src={orgInfo.watermark_on_rendering}
            label="Watermark on Rendering"
            onFileSelect={handleWatermarkImage}
            loading={savingWatermarkImg}
            disableEdit={!isAdminOrOwner}
            buttonText={`${orgInfo.watermark_on_rendering ? 'Change' : 'Add'} watermark`}
            ratio={orgInfo.watermark_on_rendering ? "3.125" : "1"}
            imageStyle={
              orgInfo.watermark_on_rendering ? {
                width: '100%',
                maxWidth: '150px',
                height: '48px',
                objectFit: 'contain',
              } : {}
            }
            containerStyle={orgInfo.watermark_on_rendering ? { width: '100%', maxWidth: '150px' } : {}}
          />
        </div>
      </div>
    </div>
  );
}
